// extracted by mini-css-extract-plugin
export default {"buy-btn":"button_buy-btn__LqVpg"};